import styled from "styled-components";
import { Flex, Typography } from "antd";
import { CaretUpOutlined } from "@ant-design/icons";

// ─── Legend Row ────────────────────────────────────────────────────────────────
// Flex handles: display, align-items, gap.
// styled adds only the typography tokens (color, font-size, text-transform).

export const LegendRowStyled = styled(Flex)`
  font-size: 12px;
  font-weight: 400;
  color: ${(p) => p.theme?.colors?.gray ?? "#565E70"};
  text-transform: capitalize;
`;

// ─── Legend Item Group ─────────────────────────────────────────────────────────
// Flex handles: display, align-items (passed as prop from JSX), gap.
// styled adds only flex-shrink:0 which has no Flex prop equivalent.
// $top prop removed — alignment is now passed directly via the align Flex prop.

export const LegendItemGroupStyled = styled(Flex)`
  flex-shrink: 0;
`;

// ─── Icons and Text ────────────────────────────────────────────────────────────

export const LegendRequiredCaretIconStyled = styled(CaretUpOutlined)`
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  font-size: 14px;
`;

export const LegendHintTextStyled = styled(Typography.Text)`
  && {
    text-transform: lowercase;
    font-size: 11px;
  }
`;
